import { FC } from 'react'
import { VStack } from '@chakra-ui/react'

export const GameSelector: FC = () => {
  return <VStack flex={1} bg="#FFD371" borderTopRadius="24px"></VStack>
}
